import type { UnsubsByPath } from "./types";

export default function getSubscribedPaths(unsubsByPath: UnsubsByPath) {
  return Object.keys(unsubsByPath);
}
